import { Injectable, NgZone } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class JourgemachineService {

  constructor(private _zone: NgZone, private _sseService: SseService, private http: HttpClient) { }

  getServerSentEvent(url): Observable<any> {
    return Observable.create((observer) => {
      const es = this._sseService.getEventSource(url);
      es.onmessage = (event) => {
        this._zone.run(() => observer.next(event));
      };
      es.onerror = (error) => {
        observer.error(error);
      };
    });
  }

   listenForUpdates(){
    return this.http.get(`readMachineData`);
  }
  getMachineData(data:any){
    return this.http.post(`getLastData`,data);
  }
  getDailyGeorgMachineDuration(){
    return this.http.get(`getDailyGeorgMachineDuration`);
  }
  getGeorgMachineReport(data){
    return this.http.post(`getGeorgMachineReport`,data);
  }
  getGeorgMachineWorkingReport(data){
    return this.http.post(`getGeorgMachineWorkingReport`,data);
  }
  getDeviceIDS():Observable<any>{
    return this.http.get(`getDeviceIds`);

  }
}
